export type FiltersForm = {
  startDate?: string;
  endDate?: string;
  determination?: string;
  deductionCode?: string;
  eligibleUnits?: [number, number];
  payoutAmount?: [number, number];
  scoreRange?: [number, number];
};

export type ExportType = 'insight' | 'raw';

export type ExportsForm = {
  title: string;
  type: ExportType;
};

export enum DrawerType {
  'Filter',
  'Export',
  'Timeframe',
}

export const clearFormValues: FiltersForm = {
  determination: '',
  deductionCode: '',
  eligibleUnits: undefined,
  payoutAmount: undefined,
  scoreRange: undefined,
};

export enum PermissionsType {
  Organization = 'organization',
  Case = 'case',
}

export enum AccountStatus {
  Active = 'active',
  Pending = 'pending_2fa',
  Denied = 'denied',
}

export const USER_ROLE_SELECTION_ITEMS = [
  {
    key: 'owner',
    value: 'Owner',
  },
  {
    key: 'admin',
    value: 'Admin',
  },
  {
    key: 'reviewer',
    value: 'Reviewer',
  },
  {
    key: 'viewer',
    value: 'Viewer',
  },
];
